import _ from 'underscore';
import SharedEditorView from '@bingads-webui-campaign-legacy/adextension-shared/view/extension-editor';
import TableRowsView from '@bingads-webui-campaign-legacy/adextension-price/view/tablerows-adapter';
import config from '@bingads-webui-component-legacy/config/index';
import UrlOptionsV2 from '@bingads-webui-component-legacy/upgraded-url/view/urlOptionsV2';
import { getSchemas } from '@bingads-webui-campaign-legacy/adextension-price/utility';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');

const permissions = config.get('permissions');
const {
  IsFinalURLSuffixPhase4Enabled,
  IsCustomParameterCountIncreasePhase3Enabled,
} = permissions;

export default class View extends SharedEditorView {
  initialize(options) {
    const { priceSchema: schema } = getSchemas();

    const fields = ['Language', 'PriceExtensionType', {
      property: 'TableRows',
      control: TableRowsView,
    }, ...IsFinalURLSuffixPhase4Enabled || IsCustomParameterCountIncreasePhase3Enabled ?
      [] : [{
        type: 'collapse',
        text: i18n.get('AdExtension_Price_Advanced_URL'),
        fields: ['TrackingUrlTemplate', 'UrlCustomParameters'],
      }]];

    if (IsFinalURLSuffixPhase4Enabled || IsCustomParameterCountIncreasePhase3Enabled) {
      const {
        extension,
        placeholderEnabled,
        isForVNext,
        campaignId,
        adgroupId: adGroupId,
      } = options;

      this.campaignId = campaignId;
      this.adGroupId = adGroupId;

      const trackingTemplate = (extension && extension.TrackingUrlTemplate) || undefined;
      const finalUrlSuffix = (extension && extension.FinalUrlSuffix) || undefined;
      const customParameters = (extension && extension.UrlCustomParameters) || undefined;

      this.urlOptions = new UrlOptionsV2({
        entityType: schema.name,

        trackingTemplate,
        finalUrlSuffix,
        customParameters,

        placeholderEnabled,
        showUurlTestTool: false,
        isForVNext,
      });
    }

    let opt = _.defaults(options, {
      schema,
      fields,
      formatting: {
        labelClass: 'col-sm-2',
        controlClass: 'col-sm-10',
      },
    });

    super.initialize(opt);
  }

  render(...args) {
    super.render(args);
    this.$('.extension-editor__container').width(1400);
    this.$('.extension-editor__form-container').width(1350);

    if (this.urlOptions) {
      this.$('.extension-editor__extra').empty().append(this.urlOptions.render().el);
    }

    return this;
  }

  remove() {
    if (this.urlOptions) {
      this.urlOptions.remove();
      this.urlOptions = null;
    }

    super.remove();
  }

  currentModel() {
    const model = super.currentModel();

    if (this.urlOptions) {
      _.extend(model, this.urlOptions.toObject());
    }

    return model;
  }
}
